import React, { useState } from "react";
import style from "./Home.module.css";

import Container from "@/layouts/container/Container";
import IncompleteCourses from "@/features/courses/components/incompleteCourses/IncompleteCourses";
import CourseSwiper from "@/features/courses/components/courseSwiper/CourseSwiper";
import CourseProgressBanner from "@/features/courses/components/courseProgressBanner/CourseProgressBanner";

import { useGetContinueWatching } from "@/features/courses/hooks/useGetContinueWatching";

import FullPageLoader from "@/ui/fullPageLoader/FullPageLoader";
import Error from "@/ui/error/Error";
import { useGetAllCourses } from "@/features/courses/hooks/useGetAllCourses";

import { useUser } from "@/features/auth/hooks/useUser";
import IndividualCourseCard from "@/features/courses/components/individualCourseCard/IndvidualCourseCard";

function Home() {
	const { user } = useUser();

	const grades = [
		"matematika",
		"matematika-eksterna-matura",
		"fizika",
		"njemacki-jezik",
		"extra",
	];

	const {
		courses: allCourses = [],
		isError: allCoursesError,
		isPending: allCoursesIsPending,
	} = useGetAllCourses();

	const {
		data: currentCourse,
		isError: currentError,
		isPending: currentPending,
	} = useGetContinueWatching();

	const hasError = currentError || allCoursesError;
	const isLoading = currentPending || allCoursesIsPending;

	if (hasError) return <Error />;
	if (isLoading) return <FullPageLoader />;

	let individualCardCount = 0;

	return (
		<div className={style.page}>
			<div className={style.background}>
				<Container>
					<CourseProgressBanner courseData={currentCourse} />
				</Container>
			</div>

			<Container>
				{grades.map((gradeSlug, index) => {
					const gradeCourses = allCourses
						.filter((course) =>
							course.categories?.some(
								(category) => category.slug === gradeSlug
							)
						)
						.sort(
							(a, b) =>
								new Date(b.date_published) -
								new Date(a.date_published)
						);

					if (gradeCourses.length === 0) return null;

					const gradeCategory = gradeCourses[0].categories.find(
						(cat) => cat.slug === gradeSlug
					);

					const shouldShowIndividualCard =
						gradeSlug === "matematika-eksterna-matura" ||
						gradeSlug === "njemacki-jezik";

					const isReversed = shouldShowIndividualCard
						? individualCardCount++ % 2 === 1
						: false;

					return (
						<React.Fragment key={gradeSlug}>
							{shouldShowIndividualCard ? (
								<IndividualCourseCard
									course={gradeCourses[0]}
									reverse={isReversed}
									color={
										gradeSlug === "njemacki-jezik"
											? "#edddec"
											: undefined
									}
								/>
							) : (
								<CourseSwiper
									title={gradeCategory?.name || gradeSlug}
									courses={gradeCourses}
								/>
							)}
						</React.Fragment>
					);
				})}
				<IncompleteCourses />
			</Container>
		</div>
	);
}

export default Home;
